<ui-search-input
  placeholder="Artikelnummer oder EAN"
  [validators]="validators"
  (searchSubmit)="search($event)"
  (validationErrorsChanged)="errors.set($event)"
  [searchText]="searchText()">
</ui-search-input>
@if (errorMessage(); as error) {
  <mat-card class="error-message">
    <mat-card-content>
     {{ error }}
    </mat-card-content>
  </mat-card>
}
